export default "__VITE_ASSET__DhDTEMA9__"